// extracted by css-extract-rspack-plugin
export default {"container":"aJNDN3yO84JODFt9","caret":"XcpVJxDW1iUqrPgG"};